import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

const className = bemClassNames("badge-component");

export enum BadgeVariant {
    /** Základní zobrazení */
    default = "default",
    /** Zobrazení při použití BackgroundAttr, kdy se načítá barva pozadí z nadřazeného HTML elementu. */
    backgroundAttr = "backgroundAttr",
}
export type BadgeProps = {
    children: ReactNode;
    /** Varianta zobrazení odznaku */
    variant?: BadgeVariant;
    /** Barva pozadí */
    backgroundColor?: string;
    /**Barva textu */
    textColor?: string;
};

/** Komponenta, která zobrazí badge/tag pro atribut */
export const Badge: FunctionComponent<BadgeProps> = ({
    children,
    variant = "default",
    backgroundColor,
    textColor,
}) => (
    <div className={className({ variant })} style={{ backgroundColor, color: textColor }} >
        {children}
    </div >
);
